export const cookiesStorage = {
  getCookie: (cookieName: string) => {
    const name = cookieName + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  },

  saveCookie: (name: string, value: string, expired?: number) => {
    let date = new Date()
    if (expired) {
      date.setTime(date.getTime() + expired)
    } else {
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
    }
    document.cookie = `${name}=${value};Domain=${
      process.env.REACT_APP_COOKIE_DOMAIN
    };Path=/;Expires=${date.toUTCString()};`
  },

  deleteCookie: (name: string) => {
    document.cookie = name + '=; Path=/;Expires=Thu, 01 Jan 1970 00:00:00 GMT'
  },

  deleteAllCookies: () => {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const equalPosition = cookie.indexOf('=')
      const name = equalPosition > -1 ? cookie.substr(0, equalPosition) : cookie
      document.cookie = `${name}=;Path=/;Domain=${process.env.REACT_APP_COOKIE_DOMAIN};Expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/services/cookiesStorage.ts